export default __webpack_public_path__ + "static/media/drop-more-btn.586e642e.webp";